import About from '@/components/pages/site/About'
import TermsOfUse from '@/components/pages/site/TermsOfUse'
import DMCAPolicy from '@/components/pages/site/DMCAPolicy'
import PaymentFees from '@/components/pages/site/PaymentFees'
import PrivacyPolicy from '@/components/pages/site/PrivacyPolicy'
import Press from '@/components/pages/site/Press'
import StreamingGuide from '@/components/pages/site/StreamingGuide'

import PhotoContest from '@/components/pages/site/2018-12-PhotoContestRules'
import VideoContest from '@/components/pages/site/2019-6-VideoContestRules'

export default [
  { path: '/site/about/', name: 'site-about', component: About, meta: { hideSidebar: true } },
  { path: '/site/tos/', name: 'site-tos', component: TermsOfUse, meta: { hideSidebar: true } },
  { path: '/site/dmca/', name: 'site-dmca', component: DMCAPolicy, meta: { hideSidebar: true } },
  { path: '/site/fees/', name: 'site-fees', component: PaymentFees, meta: { hideSidebar: true } },
  { path: '/site/privacy/', name: 'site-privacy', component: PrivacyPolicy, meta: { hideSidebar: true } },
  { path: '/site/press/', name: 'site-press', component: Press, meta: { hideSidebar: true } },
  { path: '/site/streaming-guide/', name: 'site-streaming-guide', component: StreamingGuide, meta: { hideSidebar: true } },
  {
    path: '/site/contests/photo-contest-2018-12/',
    name: 'site-rules-photo-contest-2018-12',
    component: PhotoContest,
    meta: {
      hideSidebar: true
    }
  },
  {
    path: '/site/contests/video-contest-2019-6/',
    name: 'site-rules-video-contest-2019-6',
    component: VideoContest,
    meta: {
      hideSidebar: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/site.js